import classNames from "classnames";
import React, { useState } from "react";
import { t } from "ttag";

import { FormSubmit } from "../../../forms";
import { FinancingPlan } from "../../../models/financing";
import { IMonths, isoMonths } from "../../../models/nominals";
import { IPayment, IReduxFormState } from "../reducers.interfaces";
import { FinePrint } from "./PaymentMethod_Financing_FinePrint";
import { SelectPlanForm } from "./PaymentMethod_Financing_SelectPlanForm";

interface IProps {
    methodKey: string;
    form: IReduxFormState;
    plans: readonly FinancingPlan[];
    grandTotal: string;
    setPaymentMethodFields: (
        methodKey: string,
        fields: Partial<IPayment>,
    ) => void;
    disabled: boolean;
}

export const RequestLimitIncrease = (props: IProps): React.ReactNode => {
    const [currentPlanMonths, setCurrentPlanMonths] = useState(0);

    const onSetPlanMonths = (months: IMonths) => {
        setCurrentPlanMonths(isoMonths.unwrap(months));
    };

    const submitClasses = classNames({
        "button": true,
        "button--full-width": true,
        "button--place-order": true,
        [`checkout-place-order-button--wf-${currentPlanMonths}`]: true,
        [`al-checkout__place-order-button--wf-${currentPlanMonths}`]: true,
    });

    return (
        <div className="accordion-target accordion-target--checkout-finance">
            <span className="financing-new-account__arrow-down"></span>
            <div>
                <div>
                    {t`To request a credit limit increase, call Wells Fargo at 1-800-459-8451, Monday – Friday, 9 am – 7 pm Eastern Time.`}
                </div>
                <br />
                <div>
                    {t`If Wells Fargo grants an increased credit limit that covers your order total, you may continue placing your order. If your request is denied, please choose one of the remaining options to complete your order.`}
                </div>
            </div>
            <div className="financing-form__plan-select financing-new-account__plan-select">
                <SelectPlanForm
                    methodKey={props.methodKey}
                    form={props.form}
                    plans={props.plans}
                    grandTotal={props.grandTotal}
                    setPlanMonths={onSetPlanMonths}
                    setPaymentMethodFields={props.setPaymentMethodFields}
                    disabled={props.disabled}
                />
                <FinePrint />
                <FormSubmit value={t`Place Order`} className={submitClasses} />
            </div>
        </div>
    );
};
